import React from 'react';

const SITE_URL = 'https://www.doctorite.ai';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Doctorite',
  legalName: 'Doctorite Inc.',
  url: SITE_URL,
  logo: `${SITE_URL}/favicon-192.png`,
  description:
    'AI-powered behavioral health platform with real-time session intelligence, automated documentation, and a complete EHR — built for therapists, clinics, and group practices.',
  foundingDate: '2020',
  sameAs: ['https://www.linkedin.com/company/doctorite/'],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+1-682-373-5380',
      contactType: 'customer support',
      email: 'hello@doctorite.ai',
      availableLanguage: ['English'],
      areaServed: 'US',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '18240 Midway Road',
    addressLocality: 'Dallas',
    addressRegion: 'TX',
    postalCode: '75287',
    addressCountry: 'US',
  },
};

const softwareApplicationSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Doctorite',
  applicationCategory: 'HealthApplication',
  applicationSubCategory: 'Behavioral Health EHR',
  operatingSystem: 'Web, iOS, Android',
  url: SITE_URL,
  description:
    'AI-powered behavioral health platform: real-time session intelligence, automated SOAP/DAP/BIRP notes, telehealth, scheduling, billing, and outcome tracking.',
  offers: {
    '@type': 'Offer',
    priceCurrency: 'USD',
    price: '149',
    priceSpecification: {
      '@type': 'UnitPriceSpecification',
      price: '149',
      priceCurrency: 'USD',
      unitText: 'per provider per month, billed annually',
    },
  },
  publisher: {
    '@type': 'Organization',
    name: 'Doctorite Inc.',
  },
};

export function OrganizationSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
    />
  );
}

export function SoftwareApplicationSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareApplicationSchema) }}
    />
  );
}

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function BreadcrumbSchema({ items }: { items: BreadcrumbItem[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url.startsWith('http') ? item.url : `${SITE_URL}${item.url}`,
    })),
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
